import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

interface Destinatario {
  tipo: string;
  destinatario: string;
  descripcion: string;
  horarioInicio: string;
  horarioFin: string;
}

@Component({
  selector: 'app-editar-destinatario',
  templateUrl: './editar-destinatario.component.html',
  styleUrls: ['./editar-destinatario.component.scss']
})
export class EditarDestinatarioComponent {
  destinatario: Destinatario;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.destinatario = {
      tipo: 'Chat',
      destinatario: '',
      descripcion: '',
      horarioInicio: '',
      horarioFin: ''
    };
  }

  myOptions = [
    { label: 'Workgroup', value: 'workgroup' },
    { label: 'Email', value: 'email' },
    { label: 'Chat', value: 'chat' },
  ];

  onSelected(selectedValue) {
    //this.encoladoMaximo= selectedValue;
  }

  ngOnInit() {
    const destinatarioId = this.route.snapshot.paramMap.get('id');
    this.cargarDestinatario(destinatarioId);
  }

  cargarDestinatario(id: string | null) {
    // Aquí iría la lógica para cargar los datos del destinatario con el ID dado
    if (id === 'DEC_AFONASA_CHAT') {
      this.destinatario = {
        tipo: 'Workgroup',
        destinatario: 'DEC_AFONASA_CHAT',
        descripcion: 'Declaración de nóminas',
        horarioInicio: '09:00',
        horarioFin: '18:00'
      };
    }
  }

  volver() {
    this.router.navigate(['/gestiondestinatario']);
  }
}
